import { format } from 'date-fns'

export function encodeSelectedSchools(schools: { id: string; name: string }[], visitDate?: string) {
  let focus = ''
  if (visitDate) {
    focus = `focus=${format(new Date(visitDate), 'yyyyMMdd')}&`
  }
  return `${focus}selectedSchools=${encodeURIComponent(JSON.stringify(schools))}`
}
